import _ from "lodash";

const targetedHealthCenterIds = healthCenterConfig =>
  _.compact(_.concat(healthCenterConfig.healthCenterId, healthCenterConfig.healthCenterIds));

const appliesTo = healthCenterId => healthCenterConfig =>
  _.includes(targetedHealthCenterIds(healthCenterConfig), healthCenterId);

/**
 * Finds the entry of REACT_APP_HEALTH_CENTERS_RULES that applies to a health center.
 * An entry targets either a single center (`healthCenterId`) or several centers sharing
 * the same config (`healthCenterIds`); each center is expected to appear in one entry only.
 * @param {Array<Object>} healthCentersConfigs parsed REACT_APP_HEALTH_CENTERS_RULES
 * @param {number} healthCenterId
 * @returns {Object|undefined} the matching entry (`{ alias?, rules }`), if any
 */
export const findHealthCenterConfig = (healthCentersConfigs, healthCenterId) =>
  _.find(healthCentersConfigs, appliesTo(healthCenterId));
